// extracted by mini-css-extract-plugin
export default {"card":"request-form_card__kgU0A","card_wrap":"request-form_card_wrap__HRPx4","spin":"request-form_spin__9jdhu"};